import cookies from './util.cookies'
import storejs from 'store'
import _ from 'lodash'
import axios from 'axios';
import CryptoJS from "crypto-js";

const util = {
  cookies
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  let appName = localStorage.getItem('loginAppName')
  const processTitle = appName || process.env.VUE_APP_TITLE || '保加网'
  console.log(appName,process)
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}


/**
 * @description ID 加密
 */
util.encryptId = function (id) {
  let key = CryptoJS.enc.Utf8.parse("GDi$1h8#sph1jDkl");
  let iv = CryptoJS.enc.Utf8.parse("n9ush7sdajsbf8D8");
  let srcs = CryptoJS.enc.Utf8.parse(id);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv,
  });
  return (encrypted.toString())
}

util.jsGetAge = function (strBirthday) {
  // strBirthday = '1935-09-17'
  var returnAge;
  var birthYear = strBirthday.slice(0, 4);
  var birthMonth = strBirthday.slice(5, 7);
  var birthDay = strBirthday.slice(8);
  console.log(strBirthday, birthYear, birthMonth, birthDay)

  var d = new Date();
  var nowYear = d.getFullYear();
  var nowMonth = d.getMonth() + 1;
  var nowDay = d.getDate();

  if (nowYear == birthYear) {
    returnAge = 0; //同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear; //年之差
    if (ageDiff > 0) {
      console.log(nowMonth, birthMonth)
      if (nowMonth == birthMonth) {
        console.log(nowDay - birthDay)
        var dayDiff = nowDay - birthDay; //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth; //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  }

  return returnAge; //返回周岁年龄
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

util.urlParse = function(){
  let obj = {};
  let reg = /[?&][^?&]+=[^?&%]+/g;
  let url = window.location.search;
  try {
    url = decodeURIComponent(url);  
    if (url) {
      let arr = url.match(reg);
      if (arr == null) return {}
      arr.forEach((item) => {
        let paramStr = item.substring(1);
        let firstIdx = paramStr.indexOf('=');
        let key = paramStr.substring(0, firstIdx);
        let val = paramStr.substring(firstIdx+1);
        obj[key] = val;
      })
      return obj;
    } else {
      return {}
    }
  } catch (error) {
    url = window.location.search;
    if (url) {
      let arr = url.match(reg);
      if (arr == null) return {}
      arr.forEach((item) => {
        let tempArr = item.substring(1).split('=');
        let key = decodeURIComponent(tempArr[0]);
        let val = decodeURIComponent(tempArr[1]);
        obj[key] = val;
      })
      return obj;
    } else {
      return {}
    }
  }
  // if(url){
  //   let arr = url.match(reg);
  //   arr.forEach((item) => {
  //       let tempArr = item.substring(1).split('=');
  //       let key = decodeURIComponent(tempArr[0]);
  //       let val = decodeURIComponent(tempArr[1]);
  //       obj[key] = val;
  //   })
  //   return obj;
  // }else{
  //   return {}
  // }
  
}

/**
 * @description 将对象转化为url参数
 * @param {Object} data 数据对象
 */
util.objToParameter = function (data) {
  let param = "";
  for (let key in data) {
    let value = data[key] === null ? "" : data[key];
    param = param + key + "=" + value + "&";
  }
  param = param.substring(0, param.length - 1);
  return param;
}

/**
 * @description 判断是否有权限
 * @param {String} data 权限值
 * @param {Array} data 权限数组
 */

util.hasPermission = function (permission, permissionArray) {
  if (!permissionArray) {
    permissionArray = storejs.get('permissions') || [];
  }
  let result = false;
  permissionArray.forEach(item => {
    if (item === permission) {
      result = true;
    }
  });
  return result;
}

/**
 * @description 获取今日偏移量的日期
 * @param {Number} day 偏移量
 */
util.getDay = function (day) {

  const doHandleMonth = function (month) {
    let m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }

  let today = new Date();
  let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  let tYear = today.getFullYear();
  let tMonth = today.getMonth();
  let tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
}

/**
 * @description 判断用户是否在中用户数组中
 * @param {Array} array 
 * @param {Array} ele 
 */
util.isInUsers = function (users, user) {
  let itExist = false;
  users.forEach(u => {
    if (u.id === user.id) {
      itExist = true;
    }
  });
  return itExist;
}

/**
 * @description 判断元素是否存在于数组之中
 * @param {Array} array 
 * @param {Array} ele 
 */
util.isInArrayByString = function (array, str) {
  if (!array) array = [];
  let itExist = false;
  array.forEach(s => {
    if (s === str) {
      itExist = true;
    }
  });
  return itExist;
}

/**
 * @description 动态加载js文件
 * @param {String} JsUrl 
 * @param {Function} callback 
 */
util.loadJs = function (JsUrl, callback) {
  var script = document.createElement('script');
  script.type = "text/javascript";
  if (typeof (callback) != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          if (typeof callback === "function") {
            callback();
          }
        }
      }
    } else {
      script.onload = function () {
        if (typeof callback === "function") {
          callback();
        }
      }
    }
  }
  script.src = JsUrl;
  document.body.appendChild(script);
}

/**
 * @description 文件流方式导出
 * @param {String} JsUrl 
 * @param {Function} callback 
 */
util.exportFile = function (postUrl, intoParams, vueInstance) {
  let params = null;
  postUrl = postUrl.replace("/api/", "")
  let action = '/api/' + (postUrl[0] === '/' ? postUrl.substr(1) : postUrl);
  let flyAction = '/api/' +  (postUrl[0] === '/' ? postUrl.substr(1) : postUrl);
  function fromExport() {
    if (_.isArray(intoParams)) {
      params = intoParams;
    }
    else if (_.isPlainObject(intoParams)) {
      params = [];
      _.map(intoParams, function (v, k) {
        params.push({ name: k, value: v });
      });
    }
    if (!!postUrl && _.isArray(params)) {
      let form = document.createElement('form');
      form.setAttribute("style", "display:none");
      form.setAttribute("target", "");
      form.setAttribute("method", "post");
      form.setAttribute("action", action);
      //带上token和时间戳
      params.push({ name: 'open-token', value: cookies.get('token') });
      _.each(params, function (param) {
        var input = document.createElement('input');
        input.setAttribute("type", "hidden");
        input.setAttribute("name", param.name);
        input.setAttribute("value", param.value);
        form.appendChild(input);
      });
      document.body.appendChild(form);//将表单放置在web中
      form.submit();//表单提交
      form.parentNode.removeChild(form);
    }
  }
  console.log('1233——',flyAction)
  axios.post(flyAction, intoParams).then((res) => {
    if ( res.code ) {
      if ( vueInstance ) {
        vueInstance.$message.error(res.msg);
      } else {
        alert(res.msg);
      }
    } else {
      fromExport();
    }
  }).catch((err) => {
    if ( vueInstance ) {
      vueInstance.$message.error(err);
    } else {
      alert(err);
    }
  });
}

util.isPone = function isPoneAvailable(poneInput) {
  var myreg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
  if (!myreg.test(poneInput)) {
    return false;
  } else {
    return true;
  }
}

util.isEmail = function isEmailAvailable(emailInput) {
  var myreg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!myreg.test(emailInput)) {
    return false;
  } else {
    return true;
  }
}

util.isCardID = function (card) { //验证身份证
  // let myreg=/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
  // if (!myreg.test(str)) {
  //     return false;
  // } else {
  //     return true;
  // }
  var vcity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };

  let checkCard = function (card) {

    //是否为空
    if (card === '') {

      return false;
    }
    console.log(1)
    //校验长度，类型
    if (isCardNo(card) === false) {

      return false;
    }
    console.log(2)
    //检查省份
    if (checkProvince(card) === false) {
      return false;
    }
    console.log(3)
    //校验生日
    if (checkBirthday(card) === false) {
      return false;
    }
    console.log(4)
    //检验位的检测
    if (checkParity(card) === false) {
      return false;
    }
    console.log(5)

    return true;
  };


  //检查号码是否符合规范，包括长度，类型
  let isCardNo = function (card) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
    if (reg.test(card) === false) {
      return false;
    }

    return true;
  };

  //取身份证前两位,校验省份
  let checkProvince = function (card) {
    var province = card.substr(0, 2);
    if (vcity[province] == undefined) {
      return false;
    }
    return true;
  };

  //检查生日是否正确
  let checkBirthday = function (card) {
    var len = card.length;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len == '15') {
      var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
      var arr_data = card.match(re_fifteen);
      var year = arr_data[2];
      var month = arr_data[3];
      var day = arr_data[4];
      var birthday = new Date('19' + year + '/' + month + '/' + day);
      return verifyBirthday('19' + year, month, day, birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len == '18') {
      var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
      var arr_data = card.match(re_eighteen);
      var year = arr_data[2];
      var month = arr_data[3];
      var day = arr_data[4];
      var birthday = new Date(year + '/' + month + '/' + day);
      console.log('birthday',birthday)
      return verifyBirthday(year, month, day, birthday);
    }
    return false;
  };

  //校验日期
  let verifyBirthday = function (year, month, day, birthday) {
    var now = new Date();
    var now_year = now.getFullYear();
    //年月日是否合理
    if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
      //判断年份的范围（0岁到200岁之间)
      var time = now_year - year;
      if (time >= 0 && time <= 200) {
        return true;
      }
      return false;
    }
    return false;
  };

  //校验位的检测
  let checkParity = function (card) {
    //15位转18位
    card = changeFivteenToEighteen(card);
    var len = card.length;
    if (len == '18') {
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var cardTemp = 0,
        i, valnum;
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[cardTemp % 11];
      if (valnum == card.substr(17, 1)) {
        return true;
      }
      return false;
    }
    return false;
  };

  //15位转18位身份证号
  let changeFivteenToEighteen = function (card) {
    if (card.length == '15') {
      var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
      var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
      var cardTemp = 0,
        i;
      card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      card += arrCh[cardTemp % 11];
      return card;
    }
    return card;
  };

  let flag = checkCard(card)
  return flag
}

export default util
